module.exports = __webpack_public_path__ + "static/attention-28b90f1a98ced86ee562c98c00de9e27.png";